import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { IconArrowRight, IconPhone } from './ui/Icon'
import { HOME_BY_LANG, hasOwnRfq, langFromPath, normalizePath } from '../lib/routes'
import { PHONE_HREF } from '../data/rfq-i18n'
import './mobile-rfq.css'

const COPY = {
    tr: { cta: 'Teklif İste', call: 'Telefon' },
    en: { cta: 'Get a Quote', call: 'Phone' },
    de: { cta: 'Angebot Anfordern', call: 'Telefon' },
}

const SHOW_AFTER_PX = 520

/**
 * Phone-width RFQ bar: appears once the visitor has scrolled past the first
 * screen, steps aside while the RFQ section itself is on screen. CSS keeps it
 * off wider screens and off until a cookie choice has been made.
 */
export default function MobileRfqBar() {
    const { pathname } = useLocation()
    const path = normalizePath(pathname)
    const lang = langFromPath(path)
    const t = COPY[lang]
    const home = HOME_BY_LANG[lang]
    const ownRfq = hasOwnRfq(path)
    const homeContact = home === '/' ? '/#contact' : `${home}#contact`
    const href = ownRfq ? '#contact' : homeContact

    const [pastFold, setPastFold] = useState(false)
    const [rfqVisible, setRfqVisible] = useState(false)

    useEffect(() => {
        const onScroll = () => setPastFold(window.scrollY > SHOW_AFTER_PX)
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [pathname])

    useEffect(() => {
        const target = document.getElementById('contact')
        if (!target || typeof IntersectionObserver === 'undefined') return undefined
        const observer = new IntersectionObserver(([entry]) => setRfqVisible(entry.isIntersecting), {
            rootMargin: '0px 0px -20% 0px',
        })
        observer.observe(target)
        return () => {
            observer.disconnect()
            // The next route starts with its RFQ section unseen.
            setRfqVisible(false)
        }
    }, [pathname])

    const shown = pastFold && !rfqVisible

    return (
        <div className="mobile-rfq" data-shown={shown || undefined} inert={!shown}>
            <a href={PHONE_HREF} className="mobile-rfq-call" aria-label={t.call}>
                <IconPhone size={22} />
            </a>
            <a href={href} className="btn mobile-rfq-cta">
                {t.cta}
                <IconArrowRight />
            </a>
        </div>
    )
}
